import styled from "styled-components"

export const Wrapper = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    top: ${props => props.startTop}px;
    left: ${props => props.startLeft}px;
    width: 50px;
    height: 50px;
    z-index: 9999;
    animation: flyToCart 1s;

    @keyframes flyToCart {
        from {
            transform: translate(0px, 0px);
        }
        to {
            transform: translate(${props => props.endLeft}px, ${props => props.endTop}px);
        }
    }
`